export const options = {
  width: 658,
  height: 360,
  pointSize: 4,
  lineWidth: 0,
  chartArea: {
    width: 620,
    height: 330,
    left: 26,
    top: 8
  },
  fontSize: 10,
  fontName: 'Inter',
  areaOpacity: 0.6,
  dataOpacity: 0.6,
  colors: ['#5189f7', '#2a5dca'],
  legend: {
    position: 'none'
  },
  hAxis: {
    textStyle: {
      color: '#536283'
    },
    maxTextLines: 1,
    minTextSpacing: 3
  },
  vAxis: {
    minValue: 0,
    maxValue: 10,
    baselineColor: '#edf2f8',
    gridlines: {
      count: 10,
      color: '#edf2f8'
    },
    minorGridlines: {
      count: 0
    },
    textStyle: {
      color: '#536283'
    },
    maxTextLines: 1,
    minTextSpacing: 3
  },
  focusTarget: 'category',
  tooltip: {
    trigger: 'focus'
  },
  crosshair: {
    trigger: 'focus',
    orientation: 'vertical',
    color: '#dde6f2'
  }
};
